// @purpose STATE
// Pairs with templates/cotton/button.html + components.css `.btn`. htmx already toggles
// `.htmx-request` on the triggering element for the pending spinner (CSS handles that alone, no JS
// needed) — this only adds the bit CSS can't: flashing `data-state="success"` for
// --duration-success (1.2s, tokens.css) after a successful request, then reverting to idle.
export function initButtonStates(root = document) {
  root.addEventListener("htmx:afterRequest", (event) => {
    const btn = event.target.closest(".btn");
    if (!btn) return;
    if (event.detail.successful) {
      btn.dataset.state = "success";
      setTimeout(() => {
        if (btn.dataset.state === "success") btn.dataset.state = "idle";
      }, 1200);
    } else {
      btn.dataset.state = "idle";
    }
  });
}
